/**
 * @function ParticipantList
 * @description Component for displaying a list of participants.
 * @returns {JSX.Element | null} - The ParticipantList component.
 */
import { useNavigate, useParams } from 'react-router-dom'
import { useGetParticipantsCountQuery, useGetParticipantsQuery } from '../../services/participants'
import { Search } from '../elements/Search'
import { Pagination } from '../Pagination'
import { ParticipantListEmpty } from './ParticipantListEmpty'
import { ParticipantListTable } from './ParticipantListTable'

/**
 * @function ParticipantList
 * @description Component for displaying a list of participants.
 * @returns {JSX.Element | null} - The ParticipantList component.
 */
export function ParticipantList() {
    const navigate = useNavigate()
    const { filter } = useParams()

    const sp = new URLSearchParams(location.search)
    if (filter !== 'all') {
        sp.append('status', filter)
    }

    const { data: participants, isLoading } = useGetParticipantsQuery(sp.toString())
    const { data: total } = useGetParticipantsCountQuery(sp.toString())

    function handleRowClick(participant: Novoic.API.Participant) {
        navigate(`/app/participants/${participant.studies?.[0]?.status}/${participant.id}`)
    }

    if (isLoading) {
        return null
    }

    return (
        <div className="relative w-full">
            <div className="flex flex-col gap-y-6 flex-wrap fixed top-0 left-[256px] right-0 p-8 bg-white z-10 border-b">
                <div className="flex items-center">
                    <span className="text-2xl font-semibold mr-3">Participants</span>
                </div>
                <div className="flex gap-x-2 z-20">
                    <Search placeholder="Search ID or name..." />
                    {/* <Filters /> */}
                </div>
            </div>
            <div className="flex flex-wrap bg-white mt-[161px]">
                <div className="w-full min-h-[calc(100vh_-_204px)] flex flex-wrap">
                    <div className="inline-block min-w-full align-middle">
                        <div className="flex flex-col">
                            <ParticipantListTable
                                data={participants}
                                onRowClicked={handleRowClick}
                            />
                            {participants?.length === 0 ? (
                                <ParticipantListEmpty />
                            ) : (
                                <div className="flex w-full h-[74px] items-center bg-white border-t border-t-gray-200">
                                    <Pagination total={total?.count} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
